var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderCancelled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10340",
    "data-name": "Group 10340",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#dc492b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10338",
    "data-name": "Group 10338",
    transform: "translate(1.502 -0.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M19124.289,22893.76a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,19124.289,22893.76Zm-11,0a2.5,2.5,0,1,1,2.5,2.5A2.495,2.495,0,0,1,19113.291,22893.76Zm1.971-3.932a1.519,1.519,0,0,1-1.4-.93l-7.182-17.24h-3.535v-3.027h3.535a3.016,3.016,0,0,1,2.8,1.861l1.748,4.2h20.7a1.516,1.516,0,0,1,1.414,2.045l-4.539,12.119a1.522,1.522,0,0,1-1.42.977Zm1.006-3.027h10.061l3.4-9.086h-17.244Z",
    transform: "translate(-19058.789 -22849.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xmark",
    d: "M4.724,100.012a.486.486,0,1,1-.688.688l-1.6-1.6-1.6,1.6a.487.487,0,0,1-.688-.688l1.6-1.6-1.6-1.6a.487.487,0,1,1,.688-.688l1.6,1.6,1.6-1.6a.487.487,0,0,1,.688.688l-1.6,1.6Z",
    transform: "translate(60.467 -65.223)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCancelled);
export default __webpack_public_path__ + "static/media/Order Cancelled.7a4c8f38958f01ba0869828d59b6a7a3.svg";
export { ForwardRef as ReactComponent };